import { AssignmentStartDateChangeSidebar } from './AssignmentStartDateChangeSidebar';
import React from 'react';

export const AssignmentStartDateChange = (props: object) => {
    return <AssignmentStartDateChangeSidebar {...props} />;
};
